
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
// Import the image directly using Vite's asset handling
import marcianoImage from '../assets/marciano.jpg';

const HeroSection = () => {
  return (
    <section className="py-16 md:py-24 px-6 relative backdrop-blur-sm">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="bg-white/80 p-8 rounded-xl backdrop-blur-sm">
            <div className="flex items-center gap-2 mb-3">
              <img 
                src="/noord-ai.png" 
                alt="Noord AI Logo" 
                className="h-12 w-auto"
              />
              <span className="text-noordpink font-medium italic">"Samen een stap naar morgen"</span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              🚀 Zet de eerste stap met AI in jouw bedrijf
            </h1>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Welkom bij Noord AI! Wij helpen ondernemers in Groningen, Drenthe en Friesland bij het ontdekken en toepassen van kunstmatige intelligentie. Of je nu wilt automatiseren, efficiënter werken of gewoon wilt begrijpen wat AI voor jouw bedrijf kan betekenen — wij staan voor je klaar.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button className="bg-noordpink hover:bg-noordpink-dark text-white px-6 py-2 rounded-md" asChild>
                <Link to="/contact">
                  📅 Plan een gratis kennismakingsgesprek
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button variant="outline" className="border-noordpink text-noordpink hover:bg-noordpink-light" asChild>
                <Link to="/diensten">
                  Onze diensten bekijken
                </Link>
              </Button>
            </div>
          </div>
          
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute -inset-1 bg-noordpink/20 rounded-full blur-md"></div>
              <img 
                src={marcianoImage} 
                alt="Marciano" 
                className="relative w-full max-w-md rounded-2xl shadow-xl object-cover z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
